import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface IOpenPageOrPopupArgs {
    menuId?  : string;
    popupId? : string;
    openerId?: string;
    props?   : any;
}

interface FrameState {
    activeKey       : string;
    isOpenPopup     : boolean;
    modalBounds     : object;
    title           : string;
    showLoading     : boolean;
    showMsgPopup    : boolean;
    showProgress    : boolean;
    jwtToken        : string;
    mdiItems        : [];
    currentTopMenuKey : string;
    lnbWidth : string;
    lnbCollapsed: boolean;
    lnbMenuItems : [];
    Component: any;
    menuPath: string;
    activeProps: any,
    msgItem: any;
    routeItem:any;
    relVal: string;
    allLnbMenuItems: [];
    authBoardItems: any;
    topMenuItems: [];
    popupItems: any[];
    ComponentList: any[];
    allMenuItems: any[];
}
  
const initialState: FrameState = {
    relVal: '',
    allLnbMenuItems: [],
    authBoardItems: {},
    topMenuItems: [],
    activeKey: '',
    isOpenPopup: false,
    modalBounds: { left: 0, top: 0, bottom: 0, right: 0 },
    title           : '',
    showLoading     : false,
    showMsgPopup    : false,
    showProgress    : false,
    jwtToken        : '',
    mdiItems          : [],
    currentTopMenuKey : '',
    lnbWidth : '200',
    lnbCollapsed: false,
    lnbMenuItems: [],
    Component: null,
    menuPath: '게시판 > 전체게시판',
    activeProps: {},
    routeItem: {},
    msgItem: {},
    popupItems: [],
    ComponentList:[],
    allMenuItems: [],
}

export const frameSlice = createSlice({
    name: "withinfo_frame",
    initialState: initialState,
    reducers: {
        setCurrentTopMenuKey: (state, action:PayloadAction<string>) => {
            state.currentTopMenuKey = action.payload
        },
        setActiveKey: (state, action:PayloadAction<string>) => {
            state.activeKey = action.payload
        },
        setIsOpenPopup: (state, action:PayloadAction<boolean>) => {
            state.isOpenPopup = action.payload
        },
        setModalBounds: (state, action:PayloadAction<object>) => {
            state.modalBounds = action.payload
        },
        setJwtToken: (state, action:PayloadAction<string>) => {
            state.jwtToken = action.payload
        },
        setLnbWidth: (state, action:PayloadAction<string>) => {
            state.lnbWidth = action.payload
        },
        setLnbCollapsed: (state, action:PayloadAction<boolean>) => {
            state.lnbCollapsed = action.payload
        },
        setMenuPath:(state, action:PayloadAction<string>) => {
            state.menuPath = action.payload
        },
        setComponent: (state, action:PayloadAction<any>) => {
            state.Component = action.payload
        },
        setActiveProps: (state, action:PayloadAction<any>) => {
            state.activeProps = action.payload
        },
        setLnbMenuItems: (state, action:PayloadAction<[]>) => {
            state.lnbMenuItems = action.payload
        },
        setAllMenuItems: (state, action:PayloadAction<[]>) => {
            state.allMenuItems = action.payload
        },
        setShowLoading: (state, action:PayloadAction<boolean>) => {
            state.showLoading = action.payload
        },
        setMdiItems: (state, action:PayloadAction<[]>) => {
            let arr : any['items'] = [...state.mdiItems];

            let val = JSON.stringify(action.payload);
            val = JSON.parse(val)[0];

            const ttt = arr.filter((item:string) => {
                return item === val
            });

            if (ttt.length < 1) {
                arr.push(...action.payload);
                return {
                    ...state,
                    mdiItems: arr
                }
            } else {
                return {
                    ...state,
                }
            }
        },

        setMsgItem: (state, action:PayloadAction<any>) => {
            state.msgItem = action.payload
        },

        setRouteItem: (state, action:PayloadAction<any>) => {
            state.routeItem = action.payload
        },

        setRelVal: (state, action:PayloadAction<any>) => {
            state.relVal = action.payload
        },
        setAllLnbMenuItems: (state, action:PayloadAction<any>) => {
            state.allLnbMenuItems = action.payload
        },
        setAuthBoardItems: (state, action:PayloadAction<any>) => {
            state.authBoardItems = action.payload
        },
        setTopMenuItems: (state, action:PayloadAction<[]>) => {
            state.topMenuItems = action.payload
        },
        setPopupItems: (state, action:PayloadAction<[]>) => {
            state.popupItems = action.payload
        },

        addComponentList: (state, action:PayloadAction<any>) => {
            let arr : any[] = [...state.ComponentList];

            arr = arr.filter((item:any) => {
                return item !== null;
            });

            if (action.payload) {
                arr.push(action.payload);
                return {
                    ...state,
                    ComponentList: arr
                }
            } else {
                return {
                    ...state,
                }
            }
        },

        removeComponentList: (state, action:PayloadAction<string>) => {
            let rtnArr;
            let tempArr : any[] = [...state.ComponentList];

            const idx = tempArr.findIndex((item:any) => {
                return item.name.toLowerCase() === action.payload.toLowerCase();
            });
            if(idx === 0){
                rtnArr = tempArr.slice(idx + 1, state.ComponentList.length);
            }else{
                rtnArr = tempArr.slice(0, idx);
                rtnArr = rtnArr.concat(tempArr.slice(idx + 1, tempArr.length));
            }

            return {
                ...state,
                ComponentList: rtnArr
            }
        },
    },
});

export default frameSlice.reducer;
export const FrameAction  = frameSlice.actions;
export const FrameReducer = frameSlice.reducer;